import React from 'react';
import PropTypes from 'prop-types';
import {RPMDisplay} from '../RPMDisplay';
import {ButtonControls} from '../ButtonControls';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = {
  RPM: 'RPM.string',
  SET_RPM: 'SetRPM.string',
};

export function RPMBlock(props) {
  const incrementRPM = () => {
    props.setRPM(props.value + 500);
  };
  const decrementRPM = () => {
    props.setRPM(props.value - 500);
  };

  const {t} = useTranslation();

  return (
    <div className='mc_settings_rpm'>
      <h5 className='mc_settings_rpm_title'>{t(TRANSLATION_KEY.SET_RPM)}</h5>
      <RPMDisplay displayValue={props.value} setRPM={props.setRPM} />
      <div className='mc_settings_rpm_controlBlock'>
        <ButtonControls
          text={t(TRANSLATION_KEY.RPM)}
          increment={incrementRPM}
          decrement={decrementRPM}
          altText1={`Increase RPM button. Current RPM set to ${props.value} RPM. Select to increase the RPM by 500 RPM.`}
          altText2={`Decrease RPM button. Current RPM set to ${props.value} RPM. Select to decrease the RPM by 500 RPM.`}
        />
      </div>
    </div>
  );
}

RPMBlock.propTypes = {
  /**
   * rpm value to be displayed
   */
  value: PropTypes.number,

  ...RPMDisplay.propTypes,
};

RPMBlock.defaultProps = {};
